<template>
    <div class="menu-desktop-item" v-click-outside="onClickOutside">
        <div @click="onClick" class="c-nav-item-in" :class="{'has-dropdown': hasDropdown, 'opened': isOpened}">
            <slot name="link"></slot>
        </div>
        <transition name="fade">
            <div class="c-nav-dropdown__content" v-show="isOpened">
                <slot name="default">
                    <!---->
                </slot>
            </div>
        </transition>
    </div>
</template>
<script lang="ts">
import { Component } from 'vue-property-decorator';
import BaseComponent from './Base';

@Component
    export default class NavDesktopItem extends BaseComponent {
        protected isOpened: boolean = false;
        protected hasDropdown: boolean = false;

        protected onClick(): void {
            if (this.hasDropdown) {
                this.isOpened = !this.isOpened;
            }
        }

        protected onClickOutside(event) {
            // if (event.target.parentElement.classList.contains('c-nav-item') || event.target.parentElement.classList.contains('c-top-header')|| event.target.parentElement.classList.contains('g-row')) {
            if (!event.target.parentElement.classList.contains('c-nav-dropdown')) {
                this.isOpened = false;
            }
        }

        protected checkDropdowns(): boolean {
            return !!this.$slots.default;
        }

        protected mounted(): void {
            this.hasDropdown = this.checkDropdowns();
        }
    }
</script>
<style lang="scss">
.menu-desktop-item {
    .c-nav-item-in {
        padding: 5px 10px;
        font-size: 14px;
        font-weight: 800;
        color: #333;
        cursor: pointer;

        &.opened {
            text-decoration: none;
            color: #ff6700;
        }

        &:hover,
        &:focus {
            text-decoration: underline;
        }

        a {
            color: #000;
        }
    }

    .nav-link {
        display: block;
        width: 100%;
        height: 52px;
        border-radius: .25rem;
        margin-bottom: 5px;
        padding: 10px;
        text-align: left;

        &.active {
            background-color: rgba(0, 0, 0, .06);
        }

        &:hover {
            text-decoration: underline;
            background-color: rgba(0, 0, 0, .06);
        }
    }

    .c-nav-list-item {
        &:hover {
            text-decoration: underline;
        }
    }
}

</style>
